import {
  Accordion, AccordionDetails, AccordionSummary, Box,
  Divider,
  FormControl,
  Grid, makeStyles,
  Paper,
  Tab, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead, TableRow, TableSortLabel, TextField,
  Typography
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import { useFormik } from "formik";
import { STATUS_PROCESS } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { getErrorMessage } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { isError } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    // marginBottom: 60
  },

  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
    textAlign: "center",
  },
  formGroupCenter: {
    alignItems: "center",
  },
  warpRight: {
    textAlign: "right",
    marginTop: 5,
  },
  tabs: {
    "&.Mui-selected": {
      background: "#1094D8",
      color: "white",
      borderTopLeftRadius: "15px",
      borderTopRightRadius: "15px",
    },
  },
  accordion_summary: {
    "&.MuiAccordionSummary-root.Mui-expanded": {
      backgroundColor: "#1094D8",
      color: "white",
    },
    borderRadius: 5,
    backgroundColor: "#F8F8F8",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function ViewReasonDirectorDetail() {
  const classes = useStyles();
  let { draftId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoadind] = useState(false);
  const [DialogHistory, setDialogHistory] = useState(false);
  const [DataHistoryContent, setDataHistoryContent] = useState("");
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector((state) => state.user);
  const [reasonList_data, setReasonList_data] = useState([]);
  const [reasonListDirector_data, setReasonListDirector_data] = useState([]);
  const [smartDetail, setSmartDetail] = useState([]);
  //Tab
  const [value, setValue] = useState("1");
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const headCellsDepartment = [
    {
      id: "smartDate",
      numeric: false,
      disablePadding: false,
      label: "ORGANIZATION",
    },
    {
      id: "smartNo",
      numeric: false,
      disablePadding: false,
      label: "STATUS",
    },
    {
      id: "smartNo",
      numeric: false,
      disablePadding: false,
      label: "REMARK",
    },
  ];

  const getSmartDetail = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list?draftId=${draftId}`
      );

      if (response.status) {
        response?.results.map((x) => {
          setSmartDetail(x);
        });
        return response;
      } else {
        setSmartDetail([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const getListReason = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/reason/list?draftId=${draftId}&isBOI=false`
      );

      if (response.status) {
        setReasonList_data(response.results);

        return response;
      } else {
        setReasonList_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const getListReasonDirector = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/reason/list?draftId=${draftId}&isBOI=true`
      );

      if (response.status) {
        setReasonListDirector_data(response.results);
        return response;
      } else {
        setReasonListDirector_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const forceApproveOrReject = async (params) => {
    const data = {
      draftId: draftId,
      isApprove: params === 1 ? true : false,
    };
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/froce`,
        data
      );

      if (response.status) {
        alert("สำเร็จ");
        return response;
      } else {
        alert("ไม่สำเร็จ");
      }

      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const validationSchema = yup.object({
    massDirectorToStaff: yup.string().required("Comment is required"),
  });

  let formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      massDirectorToStaff: reasonListDirector_data?.[0]?.massDirectorToStaff
        ? reasonListDirector_data?.[0]?.massDirectorToStaff
        : "",
    },
    onSubmit: async (values) => {
      const data = {
        configReasonID: reasonListDirector_data?.[0]?.configReasonID
          ? reasonListDirector_data?.[0]?.configReasonID
          : null,
        draftId: draftId,
        massDirectorToStaff: values.massDirectorToStaff,
      };

      try {
        const response = await HttpClient.post(
          "/api/visaformadmin/reason/boidirector",
          data
        );

        if (response.status) {
          alert("สำเร็จ");
          formik.setFieldValue("massDirectorToStaff", "");
          getListReasonDirector();

          return response;
        } else {
          alert("ไม่สำเร็จ");
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    },
  });

  useEffect(async () => {
    await getListReason();
    await getListReasonDirector();
    await getSmartDetail();
  }, []);

  return (
    <>
      {/* For Boi Staff */}

      <Paper
        className={classes.paper}
        style={{ marginTop: 15 }}
        id="admin-view"
      >
        <>
          <ContentTitle title="Summary of Reasons" subTitle="Smart Visa" />
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                marginTop: "10px",
              }}
            >
              <TabList
                variant="scrollable"
                scrollButtons="auto"
                onChange={handleChangeTab}
                TabIndicatorProps={{
                  style: { backgroundColor: "#1094D8" },
                }}
              >
                <Tab
                  label="The Office of the Board of Investment"
                  value="1"
                  className={classes.tabs}
                />
                <Tab label="หน่วยงานอื่นๆ" value="2" className={classes.tabs} />
              </TabList>
              <Divider style={{ backgroundColor: "#1094D8" }} />
            </Box>

            <TabPanel value="1">
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <img
                      src="/assets/images/logoBoi.png"
                      alt="smart-visa-logo"
                      style={{
                        width: 150,
                        cursor: "pointer",
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography style={{ color: "#D4DDEA", fontSize: 40 }}>
                        |
                      </Typography>
                      {reasonListDirector_data?.[0]?.isPass ? (
                        <CheckCircle
                          style={{
                            color: "#2DCE98",
                            fontSize: 50,
                            marginLeft: 5,
                          }}
                        />
                      ) : (
                        <CancelIcon
                          style={{
                            fontSize: 50,
                            marginLeft: 5,
                            color: "#FEB969",
                          }}
                        />
                      )}

                      <Typography style={{ color: "#101A5F", fontSize: 40 }}>
                        {reasonListDirector_data?.[0]?.isPass
                          ? "ผ่าน"
                          : "ไม่ผ่าน"}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={classes.warpRight}>
                      <Typography variant="h6" style={{ color: "#1094D8" }}>
                        {" "}
                        {reasonListDirector_data?.[0]?.smartserviceName
                          ? reasonListDirector_data?.[0]?.smartserviceName
                          : ""}
                      </Typography>

                      <Typography variant="h6">
                        DOC No.{" "}
                        <font color="#2DCE98">
                          {reasonListDirector_data?.[0]?.smartNo
                            ? reasonListDirector_data?.[0]?.smartNo
                            : ""}
                        </font>
                      </Typography>

                      <Typography variant="h6">
                        ความเห็นเจ้าหน้าที่ : &nbsp;
                        <font color="#101A5F">
                          {reasonListDirector_data?.[0]?.empFirstname +
                          " " +
                          reasonListDirector_data?.[0]?.empLastname
                            ? reasonListDirector_data?.[0]?.empFirstname +
                              " " +
                              reasonListDirector_data?.[0]?.empLastname
                            : ""}
                        </font>
                      </Typography>
                    </div>
                  </Grid>
                </Grid>

                {reasonListDirector_data.map((x, index) => (
                  <>
                    <Accordion
                      className={classes.accordion}
                      style={{ marginTop: 15, marginBottom: 10 }}
                      defaultExpanded={index === 0 ? true : false}
                    >
                      <AccordionSummary
                        className={classes.accordion_summary}
                        expandIcon={
                          <ExpandMoreIcon className={classes.expand_icon} />
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>
                          ความคิดเห็น วันที่{" "}
                          {moment(x?.reasonDate).format("DD/MM/YYYY ")} เวลา{" "}
                          {moment(x?.reasonDate).format("hh:mm:ss ")}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              style={{ color: "#101A5F", marginBottom: 10 }}
                            >
                              {" "}
                              ความเห็นเสนอผู้อำนวยการ
                            </Typography>
                            <Typography> {x?.commentToDirector}</Typography>
                            <Divider
                              style={{ marginTop: 10, marginBottom: 10 }}
                            />
                            <Typography
                              variant="h6"
                              style={{ color: "#00D0FF", marginBottom: 10 }}
                            >
                              {" "}
                              ร่างข้อความแจ้งผลกับผู้ยื่น
                            </Typography>
                            <Typography> {x?.commentToPersonal}</Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              style={{ color: "#2DCE98", marginBottom: 10 }}
                            >
                              {" "}
                              ความเห็นผู้อำนวยการ (Director)
                            </Typography>

                            <FormControl
                              variant="outlined"
                              fullWidth
                              className={classes.formControl}
                              style={{ marginTop: 10 }}
                            >
                              {index === 0 ? (
                                <TextField
                                  variant="outlined"
                                  name="massDirectorToStaff"
                                  value={formik.values.massDirectorToStaff}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={isError("massDirectorToStaff", formik)}
                                  helperText={getErrorMessage(
                                    "massDirectorToStaff",
                                    formik
                                  )}
                                  multiline
                                  rows={5}
                                />
                              ) : (
                                <div
                                  style={{
                                    borderColor: "#707070",
                                    backgroundColor: "#F8F8F8",
                                    borderRadius: 5,
                                    padding: 10,
                                    height: "100%",
                                  }}
                                >
                                  {" "}
                                  <Typography>
                                    {x?.massDirectorToStaff}
                                  </Typography>
                                </div>
                              )}
                            </FormControl>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </>
                ))}

                <div
                  style={{
                    marginTop: 22,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <ColorButton
                    style={{ height: 40, width: 125 }}
                    variant="outlined"
                    color="primary"
                    onClick={() => {}}
                  >
                    Back
                  </ColorButton>

                  {smartDetail?.statusProcessId ===
                    STATUS_PROCESS.FinalReviewingDirector && (
                    <>
                      <ColorButton
                        style={{
                          height: 40,
                          width: 125,
                          marginLeft: 10,
                          borderColor: "#FEB969",
                          color: "#FEB969",
                        }}
                        variant="outlined"
                        disabled={!formik.isValid}
                        type="submit"
                      >
                        Edit Draft
                      </ColorButton>
                      <ColorButton
                        style={{
                          height: 40,
                          width: 125,
                          marginLeft: 10,
                          borderColor: "#ED1C24",
                          color: "#ED1C24",
                        }}
                        variant="outlined"
                        onClick={() => forceApproveOrReject(2)}
                      >
                        Reject
                      </ColorButton>
                      <ColorButton
                        style={{
                          height: 40,
                          width: 125,
                          marginLeft: 10,
                          backgroundColor: "#2DCE98",
                          color: "white",
                        }}
                        variant="contained"
                        onClick={() => forceApproveOrReject(1)}
                      >
                        Approved
                      </ColorButton>
                    </>
                  )}
                </div>
              </form>
            </TabPanel>
            <TabPanel value="2">
              {" "}
              <TableContainer>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {headCellsDepartment.map((headCell) => (
                        <TableCell
                          className={classes.tableHead}
                          key={headCell.id}
                          align={headCell.numeric ? "right" : "left"}
                          padding={headCell.disablePadding ? "none" : "normal"}
                        >
                          <TableSortLabel
                            // disabled={headCell?.disabled || true}
                            disabled={headCell?.disabled}
                          >
                            {headCell.label}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {reasonList_data.map((x) => (
                      <StyledTableRow key="">
                        <StyledTableCell style={{ width: 300 }}>
                          {x?.departmentName}
                        </StyledTableCell>
                        <StyledTableCell style={{ width: 150 }}>
                          {x?.isPass ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              <CheckCircle
                                style={{ color: "#2DCE98", marginRight: 10 }}
                              />
                              ผ่าน
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              <CancelIcon
                                style={{ color: "#FEB969", marginRight: 10 }}
                              />
                              ไม่ผ่าน
                            </div>
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {" "}
                          {x?.commentToDirector}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>
          </TabContext>
        </>
      </Paper>
      {/* End For Boi Staff */}
    </>
  );
}

export default ViewReasonDirectorDetail;
